<div
    class="stat-item position-relative"
    [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h5>
        {{ 'Total_Production' | translate }}
    </h5>
    <div class="number lh-1 fw-medium">
        {{ '26.5' | cultural }} MWh
    </div>
    <span class="daxa-up-down-badge position-relative">
        <i class="material-symbols-outlined">
            trending_up
        </i>
        {{ '8.75' | cultural }}%
    </span>
    <div class="chart">
        <div id="crm_active_users_chart"></div>
        <div class="title d-block text-body">
            {{ 'This_Year' | translate }}
        </div>
    </div>
</div>